/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuditChiamataListFilter { 
    q?: string;
    metodo_http?: string;
    status_code?: number;
    operazione?: string;
    actor_user_id?: string;
    attore?: string;
    actor_type?: string;
    solo_modifiche?: boolean;
    da?: string;
    a?: string;
}

